import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BillingAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = BillingAccount;

export const useBalance = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query billingAccount {
      billingAccount {
        automatedInvoicing
        balance
        currency
        invoiceBalance
        invoiceDueDays
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['billingAccount'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
